import { getShareDecision } from "api";
import { Error } from "utils/Response";
import { ActionTypes } from "./types";
import { SetDecisionDetails } from "../GetDecisionDetails/action";

export const GetShareDecision = (token, decId) => async (dispatch) => {
  let query = `${token}&decision=${decId}&outer=true`;
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await getShareDecision(query);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 200) {
      dispatch(SetDecisionDetails(data));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
